'use strict';

$.fn.extend({
    toggleText: function(a, b){
        return this.text(this.text() == b ? a : b);
    }
});

// import Swiper bundle with all modules installed
//import Swiper from "swiper/bundle";

function J3WTheme() {

    var self = this;

    self.$window = $(window);
    self.$document = $(document);
    self.$body = $("body");
    self.$header = $("#js-header");
    self.$hamburger = $(".hamburger");
    self.$mainMenu = $("#js-main-menu");
    self.$mainNav = $("#main-nav");
    self.$mobileMenu = $("#js-mobile-menu");

    self.init();
}

J3WTheme.prototype = {

    init: function () {

        var self = this;

        self.onBind();
        //self.cloneMainMenu();
        self.fancybox();
        self.accordion();
        //self.swiperHeroInit();
        //self.carouselInit();

    },

    onBind: function () {

        var self = this;

        self.$window.on('scroll', function () {
            self.bodyScrollClass(self);
        });

        $("#js-feedback-box-close").on("click", function(){
           $(this).closest(".feedback-box").addClass("feedback-box--close");
        });

        self.$hamburger.on("click", function () {
            self.mobileMenu();
        });

        $("#js-open-search").on("click", function(){
            $("#js-searchbar").toggleClass("searchbar--open");
            setTimeout(function() {
                $("#js-search-text").focus();
            }, 300 );
        });

        $("#js-searchbar-bg").on("click", function(){
            $("#js-searchbar").removeClass("searchbar--open");
        });

        self.$document.keydown(function (e) {
            if (e.cancelable === true && e.key === 'Esc' || e.key === 'Escape' || e.keyCode === 27) {
                $("#js-searchbar").removeClass("searchbar--open");
            }
        });

        $(".more-info-btn").on("click", function(e) {
            $("#more-info").toggleClass("open");
            $(this).toggleClass("btn-icon--arr-expand btn-icon--arr-expand-less")
                   .toggleText('Více', 'Méně');
            e.preventDefault();
        });

    },

    newsletter: function() {

        var $form = $("#js-newsletter");

        $form.on("submit", function(e){

            e.preventDefault();

            // check email
            if ( $("#js-newsletter-email").value === '' ) {
                alert("Vyplňte e-mail");
            }
            else {
                grecaptcha.ready( function() {
                    grecaptcha.execute( '6LdzUN4pAAAAANJdZlN7SN4lBUTCBajLjeHrYWux', {action: 'submit' } ).then( function(token) {
                        // Je to ok? Tak to zpracujem
                        $form.submit();
                    } );
                } );
            }

        });

    },

    accordion: function(){

        $(".accordion").accordionjs({
            // Allow self close.(data-close-able)
            closeAble   : true,
            // Close other sections.(data-close-other)
            closeOther  : false,
            // Animation Speed.(data-slide-speed)
            slideSpeed  : 300,
            // The section open on first init. A number from 1 to X or false.(data-active-index)
            activeIndex : false,
            // Callback when a section is open
            //openSection: function( section ){},
            // Callback before a section is open
            //beforeOpenSection: function( section ){},
        });

        // Otevirame podle hashe v URL adrese
        var hash = new URL(document.URL).hash;

        if ( hash && $(".accordionjs").length > 0 ) {
            $(hash).addClass( "acc_active" ).find(".acc_content").show();
            $("html, body").animate({
                scrollTop: $(hash).offset().top - 100 // offset
            }, 150);
        }

    },

    mobileMenu: function(){

        var self = this, t;

        clearTimeout( t );

        //self.$body.toggleClass("mobile-menu-is-open");

        var $hamburger = $(".hamburger");

        if( self.$mobileMenu.hasClass("mobile-menu--open") ){
            self.$mobileMenu.removeClass("mobile-menu--open");
            t = setTimeout( function(){
                $hamburger.removeClass("is-active");
            }, 200 );
        }
        else {
            self.$mobileMenu.addClass("mobile-menu--open");
            t = setTimeout( function(){
                $hamburger.addClass("is-active");
            }, 200 );
        }

    },

    cloneMainMenu: function(){

        $("#js-main-menu:not(.cloned)").addClass("cloned")
            .clone( true, true )
            .removeAttr("id")
            .appendTo("#js-sticky-menu-container");

    },

    bodyScrollClass: function ( self ) {

        //if( self.$document.scrollTop() > self.$header.outerHeight() ) {
        if( self.$document.scrollTop() > 0 ) {
            self.$body.addClass('js-scrolling');
        }
        else {
            self.$body.removeClass('js-scrolling');
        }
/*
        // potrebujeme vedet, jestli se scrolluje dolu nebo nahoru
        if ( ( document.body.getBoundingClientRect() ).top > self.scrollPos ) {
            self.$body.addClass('scroll-up');
        } else {
            self.$body.removeClass('scroll-up');
        }

        self.scrollPos = ( document.body.getBoundingClientRect() ).top;

        if( self.$document.scrollTop() < self.$header.outerHeight() + 100 ) {
            self.$body.addClass('hide-menu');
        } else {
            self.$body.removeClass('hide-menu');
        }
*/
    },

    fancybox: function() {

        $('[data-fancybox="gallery"]').fancybox({
            loop: true,
            buttons: [
                "zoom",
                "share",
                "slideShow",
                "fullScreen",
                //"download",
                //"thumbs",
                "close"
            ]
        });
    },

    swiperHeroInit: function() {

        var self = this;

        self.swiperHero = new Swiper('#js-swiper-hero', {
            loop: true,
            speed: 900,
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            preloadImages: false,
            lazyLoading: true,
            lazy: {
                loadPrevNext: true,
            },
            /*
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            }*/
        });
    },

    carouselInit: function() {

        var self = this;

        self.swiperHero = new Swiper('#js-carousel', {
            loop: true,
            speed: 900,
            autoplay: {
                delay: 2000,
                disableOnInteraction: true
            },
            //effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            keyboard: {
                enabled: true
            },
            preloadImages: false,
            navigation: {
                nextEl: '.carousel-nav--next',
                prevEl: '.carousel-nav--prev'
            },
            on: {
                transitionEnd: function() {
                    // lazyLoadInstance defined in footer.php
                    lazyLoadInstance.update();
                }
            },
            /*
            pagination: {
                el: '.swiper-hero-pagination',
                type: 'bullets',
                clickable: true
            }*/
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                // when window width is >= 420px
                420: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 768px
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                // when window width is >= 1024px
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40
                }
            }
        });
    }
};

$(document).ready(function () {
    new J3WTheme();
});
